import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@cps'
import { getHistoryNew } from '@utils'
import themeMobx from '@mobx/app/theme.mobx'
import CategoryBtns from '../CategoryBtns'
import CollectWrap from '../CollectWrap'
import { favoMobx, mallMobx } from 'mobx/mall'
import './index.scss'
import { classNames } from '@dt/fe-utils'

const MallTop: React.FC = () => {
  const history = getHistoryNew()
  const handleBack = () => {
    const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
    if (hasHome?.isShow !== 0) {
      history.replace('/home')
    } else {
      history.replace('/menu')
    }
  }
  return (
    <div className='mall-header-container'>
      <div className='mall-header-wrapper'>
        <div className='title-wrapper'>
          <Icon name='chevron-left' onClick={handleBack} />
          <div className='title'>{i18n.t('mall.onlineMall')}</div>
        </div>
        <CollectWrap />
      </div>
      {
        mallMobx.isLoading ? null : mallMobx.products.length > 0 && (
          <div className='category-fixed-wrapper'>
            <CategoryBtns />
          </div>
        )
      }
    </div>
  )
}

export default observer(MallTop)
